import testiimage from "../../assets/images/testiimage.png";
import testiimage1 from "../../assets/images/image2.png";
import testiimage2 from "../../assets/images/image1.png";
import testiimage3 from "../../assets/images/image3.png";
import testiimage4 from "../../assets/images/image4.png";
import testiimage5 from "../../assets/images/image5.png";
import testiimage6 from "../../assets/images/image6.png";
import testiimage7 from "../../assets/images/image7.png";
import testiimage8 from "../../assets/images/image8.png";
import testiimage9 from "../../assets/images/image9.png";
import testiimage10 from "../../assets/images/image10.png";
import testiimage11 from "../../assets/images/image11.png";
import testiimage12 from "../../assets/images/image12.png";
import testiimage13 from "../../assets/images/image13.png";
import testiimage14 from "../../assets/images/image14.png";
import testiimage15 from "../../assets/images/image15.png";
import testiimage16 from "../../assets/images/image16.png";
import testiimage17 from "../../assets/images/image17.png";
import testiimage18 from "../../assets/images/image18.png";
import testiimage19 from "../../assets/images/image19.png";
import testiimage20 from "../../assets/images/image20.png";
// import testiimage21 from "../../assets/images/images21.jpg";

let image1 = testiimage
let image2 = testiimage1
let image3 = testiimage2
let image4 = testiimage3
let image5 = testiimage4
let image6 = testiimage5
let image7 = testiimage6
let image8 = testiimage7
let image9 = testiimage8
let image10 = testiimage9
let image11 = testiimage10
let image12 = testiimage11
let image13 = testiimage12
let image14 = testiimage13
let image15 = testiimage14
let image16 = testiimage15
let image17 = testiimage16
let image18 = testiimage17
let image19 = testiimage18
let image20 = testiimage19
let image21 = testiimage20

let feedback_1 = "It's great. I'm a student and my parents don't respond well to the suggestion of going to hospital for check up, they feel they always know what's up and prefer self medication. At least with Doctall, "
let feedback_2 = "It helps a lot"
let feedback_3 = "Convenient and innovative"
let feedback_4 = "Easy and accessble"
let feedback_5 = "Just excellent"
let feedback_6 = "Excellent service"
let feedback_7 = "It's very friendly"
let feedback_8 = "It's so reliable and comfortable"
let feedback_9 = "This app bring healthcare closer to you than u think...I will recommend this for everyone"
let feedback_10 = "Quickest way to get faster and at the comfort of your home"
let feedback_11 = "It's so modern with good reviews"
let feedback_12 = "I was satisfied with the service"
let feedback_13 = "Making health care accessible no matter where one is"
let feedback_14 = "Its time saving and money saving and also very effective and efficient"
let feedback_15 = "I'm really impress"
let feedback_16 = "Great service"
let feedback_17 = "It's nice"
let feedback_18 = "I love this app. It's amazing"
let feedback_19 = "Good"
let feedback_20 = "It's straight forward and convenient"
let feedback_21 = "Quite satisfied"




let user_1 = "Efe Clinton Ugbuku"
let user_2 = "Philip Marvellous Taiwo"
let user_3 = "Sjohn Oddy"
let user_4 = "Princewill Odinaka Onyema"
let user_5 = "Muslimah Nill Aminu"
let user_6 = "Emmanuel Osinachi Victor"
let user_7 = "Anisere Ahmad Adebayo"
let user_8 = "Amarachukwu Francisca Otugoh"
let user_9 = "Sulaiman Azeez Okuboye"
let user_10 = "Faith Mary"
let user_11 = "Alliy Omotayo Adams"
let user_12 = "Ini Joseph Offiong"
let user_13 = "Azeemat Titilola Abdulazeez"
let user_14 = "Osazee Mike Osahon"
let user_15 = "Babaranti Adeshina Ayomide"
let user_16 = "Oluwakemi Rufiat Lasisi"
let user_17 = "Idahosa Esogie Wealth"
let user_18 = "Odunayo Olaoluwa George"
let user_19 = "Zainab Usman"
let user_20 = "Ifinake Lilian Williams"
let user_21 = "Fakayode Omotayo Olayemi"




export const testimonialContent = [
    { userName: user_1, userFeedback: feedback_1,image: image1  },
    { userName: user_2, userFeedback: feedback_2 ,image: image2},
    { userName: user_3, userFeedback: feedback_3 ,image: image3},
    { userName: user_4, userFeedback: feedback_4 ,image: image4},
    { userName: user_5, userFeedback: feedback_5 ,image: image5},
    { userName: user_6, userFeedback: feedback_6 ,image: image6},
    { userName: user_7, userFeedback: feedback_7 ,image: image7},
    { userName: user_8, userFeedback: feedback_8,image: image8 },
    { userName: user_9, userFeedback: feedback_9,image: image9 },
    { userName: user_10, userFeedback: feedback_10 ,image: image10},
    { userName: user_11, userFeedback: feedback_11 ,image: image11},
    { userName: user_12, userFeedback: feedback_12 ,image: image12},
    { userName: user_13, userFeedback: feedback_13 ,image: image13},
    { userName: user_14, userFeedback: feedback_14 ,image: image14},
    { userName: user_15, userFeedback: feedback_15 ,image: image15},
    { userName: user_16, userFeedback: feedback_16 ,image: image16},
    { userName: user_17, userFeedback: feedback_17 ,image: image17},
    { userName: user_18, userFeedback: feedback_18 ,image: image18},
    { userName: user_19, userFeedback: feedback_19 ,image: image19},
    { userName: user_20, userFeedback: feedback_20 ,image: image20},
    { userName: user_21, userFeedback: feedback_21 ,image: image21},

]